import { Accordion, AccordionDetails, AccordionSummary, IconButton, Stack } from '@mui/material';
import React from 'react';
import { ICONS } from '@/assets/icons';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import Iconify from '@/components/Iconify';

type CollapsibleSectionProps = {
  title: React.ReactNode;
  titleEndAdornment?: React.ReactNode;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  paddingLess?: boolean;
};

const Collapsible: React.FC<CollapsibleSectionProps> = ({
  title,
  titleEndAdornment,
  children,
  defaultExpanded = true,
  paddingLess = false,
}) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      elevation={0}
      sx={{
        p: 1,
        ...(paddingLess && { p: 0 }),
        border: 'none',
        '&.Mui-expanded': {
          boxShadow: 'none',
          m: 0,
        },
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={
          <IconButton>
            <Iconify icon={ICONS.CHEVRON_DOWN} width={20} height={20} />
          </IconButton>
        }
        sx={{
          m: 0,
          ...(paddingLess && { p: 0 }),
          '&.Mui-expanded': {
            m: 0,
          },
        }}
      >
        {titleEndAdornment ? (
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <PTypography variant="subtitle1">{title}</PTypography>
            <Stack component="span" onClick={(e) => e.stopPropagation()}>
              {titleEndAdornment}
            </Stack>
          </Stack>
        ) : (
          <PTypography variant="subtitle1">{title}</PTypography>
        )}
      </AccordionSummary>
      <AccordionDetails sx={{ py: 0, ...(paddingLess && { p: 0 }) }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default Collapsible;
